import { dataHooks } from '@wix/data-hooks'

export const wixMobileSplitDataHooks = dataHooks<{
  title: {}
  description: {}
  option: { key: string; lable: string }
  next: {}
  skip: {}
}>('wix-mobile-split')
